/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveNoveltyCalcRequestBody
 */
export interface SaveNoveltyCalcRequestBody {
    /**
     * 
     * @type {string}
     * @memberof SaveNoveltyCalcRequestBody
     */
    simulationName: string;
}

/**
 * Check if a given object implements the SaveNoveltyCalcRequestBody interface.
 */
export function instanceOfSaveNoveltyCalcRequestBody(value: object): value is SaveNoveltyCalcRequestBody {
    if (!('simulationName' in value) || value['simulationName'] === undefined) return false;
    return true;
}

export function SaveNoveltyCalcRequestBodyFromJSON(json: any): SaveNoveltyCalcRequestBody {
    return SaveNoveltyCalcRequestBodyFromJSONTyped(json, false);
}

export function SaveNoveltyCalcRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveNoveltyCalcRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'simulationName': json['simulationName'],
    };
}

export function SaveNoveltyCalcRequestBodyToJSON(json: any): SaveNoveltyCalcRequestBody {
    return SaveNoveltyCalcRequestBodyToJSONTyped(json, false);
}

export function SaveNoveltyCalcRequestBodyToJSONTyped(value?: SaveNoveltyCalcRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'simulationName': value['simulationName'],
    };
}

